const commSegment = "Commodity Segment";
export const LedgerSnapShotMapper = (response) => {
    if (response) {
        let specialCaseAssetVal = 0;
        let spliceIdx = null;
        let updatedSnapShots = response.filter((currentValue, idx) => {
            if (currentValue.asset.toUpperCase() === "MCX" ||
                currentValue.asset.toUpperCase() === "NCDEX") {
                specialCaseAssetVal = specialCaseAssetVal + currentValue.assetVal;
                spliceIdx = idx;
                return false;
            }
            return true;
        });
        if (!!spliceIdx && spliceIdx > 0) {
            updatedSnapShots.splice(spliceIdx - 1, 0, {
                asset: commSegment,
                assetVal: specialCaseAssetVal,
            });
        }
        let finalResp = updatedSnapShots.map((x) => {
            return {
                asset: x.asset,
                assetVal: x.assetVal,
            };
        });
        return finalResp;
    }
    return [];
};
